export default __webpack_public_path__ + "static/media/options-icon.1eb21de5.svg";